import { render, staticRenderFns } from "./ApplicantMessageHistoryToApplicant.vue?vue&type=template&id=02084843"
import script from "./ApplicantMessageHistoryToApplicant.vue?vue&type=script&lang=js"
export * from "./ApplicantMessageHistoryToApplicant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports